"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transcodeAcceleratorTypeDisplayName = void 0;
const types_1 = require("./api/v1/types");
const transcodeAcceleratorTypeDisplayName = (type) => {
    switch (type) {
        case types_1.TranscodeAcceleratorType.nvidia:
            return 'NVIDIA NVENC';
        case types_1.TranscodeAcceleratorType.netint:
            return 'NETINT Quadra';
        case types_1.TranscodeAcceleratorType.xilinx_u30:
            return 'Xilinx U30';
        case types_1.TranscodeAcceleratorType.videotoolbox:
            return 'Apple VideoToolbox';
        case types_1.TranscodeAcceleratorType.cpu:
            return 'CPU';
        default:
            return type;
    }
};
exports.transcodeAcceleratorTypeDisplayName = transcodeAcceleratorTypeDisplayName;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhbnNjb2RlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3RyYW5zY29kZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSwwQ0FBeUQ7QUFZbEQsTUFBTSxtQ0FBbUMsR0FBRyxDQUFDLElBQThCLEVBQVUsRUFBRTtJQUMxRixRQUFRLElBQUksRUFBRSxDQUFDO1FBQ1gsS0FBSyxnQ0FBd0IsQ0FBQyxNQUFNO1lBQ2hDLE9BQU8sY0FBYyxDQUFBO1FBQ3pCLEtBQUssZ0NBQXdCLENBQUMsTUFBTTtZQUNoQyxPQUFPLGVBQWUsQ0FBQTtRQUMxQixLQUFLLGdDQUF3QixDQUFDLFVBQVU7WUFDcEMsT0FBTyxZQUFZLENBQUE7UUFDdkIsS0FBSyxnQ0FBd0IsQ0FBQyxZQUFZO1lBQ3RDLE9BQU8sb0JBQW9CLENBQUE7UUFDL0IsS0FBSyxnQ0FBd0IsQ0FBQyxHQUFHO1lBQzdCLE9BQU8sS0FBSyxDQUFBO1FBQ2hCO1lBQ0ksT0FBTyxJQUFJLENBQUE7SUFDbkIsQ0FBQztBQUNMLENBQUMsQ0FBQTtBQWZZLFFBQUEsbUNBQW1DLHVDQWUvQyJ9